/**
 * Bridge between the React `ActiveRoleProvider` and the (non-React) Apollo
 * links, so every GraphQL request can carry the role the user is currently
 * operating as via the `X-Matrix-Active-Role` header.
 *
 * The backend (`MatrixStudio.Plugs.AbsintheContext`) narrows `ctx.user.roles`
 * to this role when it's one the user actually holds — making the active role
 * the effective identity for isAdmin, tenant-tree grants, and feature grants.
 * It is pure de-escalation: the header can never introduce a role the JWT
 * doesn't already contain, and an absent/blank value simply means "operate as
 * all my roles" (the pre-existing behaviour).
 *
 * A module-level variable (not React state) is used because Apollo links live
 * outside the component tree; `ActiveRoleProvider` calls `setActiveRoleHeader`
 * whenever the selection changes.
 */
let activeRole: string | null = null;

export function setActiveRoleHeader(role: string | null): void {
  activeRole = role && role.trim() !== '' ? role : null;
}

export function getActiveRoleHeader(): string | null {
  return activeRole;
}
